import { render, staticRenderFns } from "./KeyWordTabBar.vue?vue&type=template&id=5b72b746"
import script from "./KeyWordTabBar.vue?vue&type=script&lang=js"
export * from "./KeyWordTabBar.vue?vue&type=script&lang=js"
import style0 from "./KeyWordTabBar.vue?vue&type=style&index=0&id=5b72b746&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports